// extracted by mini-css-extract-plugin
export default {"container":"cn","overlay":"dn","videoOverlay":"en","withHeader":"fn","header":"gn","close":"hn","content":"in"};